module.exports = __webpack_public_path__ + "img/other_pin.fff726cf.png";